import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/fr/terms-of-use")({
  head: () => ({
    meta: [
      { title: "Conditions d'Utilisation — Picamini.online" },
      {
        name: "description",
        content: "Consultez les conditions d'utilisation du site Picamini.online et de nos outils gratuits en ligne.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/fr/conditions-d-utilisation" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/terms-of-use" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/terminos-de-uso" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/nutzungsbedingungen" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://picamini.online/pt-br/termos-de-uso" },
      { rel: "alternate", hrefLang: "fr", href: "https://picamini.online/fr/conditions-d-utilisation" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/terms-of-use" },
    ],
  }),
  component: FrTermsPage,
});

function FrTermsPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="fr" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-foreground">Conditions d'Utilisation</h1>

        <p className="text-base text-muted-foreground leading-relaxed">
          Bienvenue sur <strong>Picamini.online</strong>. En accédant à notre site et en utilisant nos outils gratuits, vous acceptez les présentes conditions d'utilisation.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-4">1. Utilisation Autorisée</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Toutes nos applications web sont mises à disposition gratuitement pour un usage personnel, éducatif ou professionnel. Vous êtes libre d'utiliser nos outils dans vos classes, présentations, réunions et animations.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-4">2. Propriété Intellectuelle</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Le code, l'interface graphique, le design et les contenus du site Picamini.online sont la propriété exclusive de Picamini.online.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-4">3. Limitation de Responsabilité</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Les outils sont fournis "tels quels" sans garantie explicite ou implicite. Picamini.online ne saurait être tenu responsable d'éventuelles interruptions temporaires du service.
        </p>
      </main>

      <SiteFooter lang="fr" />
    </div>
  );
}
